

<template>
    <header class="header">
        <div class="progress" v-if="loading">{{storeName}} ...</div>
        <img class="logo" src="../assets/img/d2logo.png">
        <div class="d2catering">D2catering</div>
        <el-menu
            :default-active="activeIndex"
            class="topmenu"
            mode="horizontal"
            @select="handleSelect"
        >
            <el-menu-item index="catering">Кейтеринг</el-menu-item>
            <el-menu-item index="customers">Заклади</el-menu-item>
            <el-menu-item index="revision">Перегляд</el-menu-item>
            <el-menu-item index="report">Звітність</el-menu-item>
        </el-menu>
        <div class="header-update-host"></div>
        <div v-if="!hasSidebar" class="user-info" @click="openCabinet"> {{ userName }}</div>
        <el-dialog
        size="small"
        title="Особистий кабінет"
        v-model="cabinetVisible"
        :close-on-press-escape="true"
        @closed="cabinetVisible = false"
        >
            <div class="dialog-field">
                <label>Користувач:</label>
                <div>{{ userName }}</div>
            </div>
            <div class="dialog-field">
                <label>Логін:</label>
                <el-input v-model="cabinet.login" />
            </div>
            <div class="dialog-field">
                <label>e-mail:</label>
                <div>{{ cabinet.email }}</div>
            </div>
            <div class="dialog-field">
                <label>Телефон:</label>
                <el-input v-model="cabinet.phone" />
            </div>
            <div class="dialog-field">
                <label>Новий пароль:</label>
                <el-input v-model="cabinet.newPass" type="password" show-password />
            </div>
            <div class="dialog-field">
                <label>Повторіть пароль:</label>
                <el-input v-model="cabinet.newPassConfirm" type="password" show-password />
            </div>
            <template #footer>
                <div style="display:flex; align-items:center; gap:8px;">
                    <el-button type="danger" plain @click="onLogout">Вийти</el-button>
                    <span style="flex:1"></span>
                    <el-button @click="cabinetVisible = false">Скасувати</el-button>
                    <el-button
                        type="primary"
                        :loading="saving"
                        @click="onChangeCabinet"
                    >OK
                    </el-button>
                </div>
            </template>
        </el-dialog>
     </header>
</template>

<script setup>

    import { computed,inject, ref, onMounted, watch } from 'vue'
    import { useAuthStore } from '../stores/auth'
    import { ElMessage } from 'element-plus'
    import * as store from '@/stores/apiStore.js'
    import { useAccountCabinet } from '@/composables/useAccountCabinet.js'

    const configId = inject('configId',ref(null)) 

    const props = defineProps({
        activeChapter: { type: String, default: 'catering' }
    })

    const storeName = ref("")
    const loading = ref(false)
    const saving = ref(false)
    const auth = useAuthStore()
    const userName = computed(() => auth.user?.name || auth.user?.login || '')
    const activeIndex = computed(() => props.activeChapter)
    const { visible: cabinetVisible } = useAccountCabinet()
    const hasSidebar = computed(() => props.activeChapter === 'catering' || props.activeChapter === 'customers')
    const cabinet = ref({ login: '', email: '', phone: '', newPass: '', newPassConfirm: '' })

    function populateCabinet() {
        cabinet.value = {
            login: auth.user?.login || '',
            email: auth.user?.email || '',
            phone: auth.user?.phone || '',
            newPass: '',
            newPassConfirm: '',
        }
    }
    watch(cabinetVisible, (v) => { if (v) populateCabinet() })
    const emit = defineEmits(['selectedChapter'])
    const handleSelect = (key) => {
        configId.value=null
        emit('selectedChapter', key)
    }

    function openCabinet() {
        cabinetVisible.value = true
    }

    function onLogout() {
        cabinetVisible.value = false
        auth.logout()
    }

    async function onChangeCabinet() {
        const payload = {}

        if (cabinet.value.login !== auth.user?.login) {
            payload.login = cabinet.value.login
        }
        if (cabinet.value.phone !== (auth.user?.phone || '')) {
            payload.phone = cabinet.value.phone
        }
        if (cabinet.value.newPass) {
            if (cabinet.value.newPass !== cabinet.value.newPassConfirm) {
                ElMessage.error('Паролі не співпадають')
                return
            }
            payload.password = cabinet.value.newPass
            payload.password_confirm = cabinet.value.newPassConfirm
        }

        if (!Object.keys(payload).length) {
            cabinetVisible.value = false
            return
        }

        saving.value = true
        try {
            await auth.updateMe(payload)
            cabinetVisible.value = false
            ElMessage.success('Збережено')
        } catch (e) {
            ElMessage.error(e.message || 'Помилка збереження')
        } finally {
            saving.value = false
        }
    }

    onMounted(async () => {
        if (!auth.user?.login) cabinetVisible.value = true
/*
        loading.value=true
        await store.loadAll((name)=>{storeName.value=name})
        loading.value=false
*/
    })

</script>

<style scoped lang="scss">

:deep(.el-dialog) {

	border-radius: unset;
	box-shadow: 8px 8px 7px 0 grey;
	top: 0px;
	width: 600px;

	.dialog-field {
		display: flex;
		margin: 20px 0;
		max-width: 500px;
		& > div {
			line-height: 24px;
			margin-left: 20px;
			font-size: 14px;
		}

		& > label {
			font-size: 12px;
			font-weight: bold;
			height: 24px;
			line-height: 24px;
			color: var(--el-text-color-primary);
			width: 130px;
			text-align: right;
		}

		.el-input {
			flex: 1;
			flex-wrap: wrap;
			font-size: var(--font-size);
			line-height: 24px;
			height: 24px;
			margin-left: 10px;

			&__wrapper {
				height: 24px;
			}
		}
	}
}



.header {
    padding: 10px 20px 15px 20px;
}
.progress{
    position: fixed;
    width: 250px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    top: 30vh;
    left: 40vw;
    border: 1px solid silver;
    box-shadow: 3px 3px silver;
}

.logo {
    height: 70px;
    float: left;
}

.logout{
    height: 15px;
    width: 18px;
    float: right;
    margin: 5px 5px 0 0;
    cursor: pointer;
}

.d2catering{
    float: left;
    color: gray;
    font-size: 24px;
    font-weight: bold;
    line-height: 38px;
}
.user-info {
    float: right;
    line-height: 22px;
    margin-right: 5px;
    cursor: pointer;

}
/*
.el-dropdown {
    float:right;
    margin-top: 5px;
}
.el-dropdown-menu {
    min-width: 120px;
}
*/

.el-menu {
    --el-menu-horizontal-height: 30px;
    --el-menu-border-color:orange;
    --el-menu-bg-color: transparent;
    --el-menu-hover-text-color: orange;
    --el-menu-hover-bg-color:transparent;
    --el-menu-active-color:orange;
    .el-menu {
        border-bottom: 1px solid var(--el-menu-border-color);
    }
}


.el-menu-item{
    padding: 0 30px;
    transition:none;

}
.el-menu-item.is-active{
        font-weight: bold;
        border:none;
    }

.topmenu{
    width: calc(100% - 70px);
    margin-left: -127px;
    float: left;
    margin-top: 10px;

    :deep(.el-menu-item:first-child){
        margin-left: 250px;
    }
}

.header-update-host{
    float: right;
    min-width: 46px;
    min-height: 28px;
    margin-top: 0px;
}

</style>
